import { z } from 'zod';

export type MessageFormatter = (msg: { id: string; defaultMessage: string }) => string;

const imageRequiredMsg = {
  id: 'common.required',
  defaultMessage: 'Requerido',
};

/** Zod schema for the media watermark form values. */
export function getSchema(t: MessageFormatter) {
  return z.object({
    enabled: z.boolean(),
    imageUrl: z.string().min(1, t(imageRequiredMsg)),
    positionX: z.enum(['left', 'center', 'right']),
    paddingX: z.coerce.number(),
    positionY: z.enum(['top', 'center', 'bottom']),
    paddingY: z.coerce.number(),
    opacity: z.coerce.number(),
  });
}

export type MediaWatermarkFormValues = z.infer<ReturnType<typeof getSchema>>;
